import  {
  isValidPhoneNumber,
  
} from "react-phone-number-input";
import { toast } from "react-hot-toast";

export const validate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.password) {
    errors.password = "Password is required";
  } else if (
    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/i.test(
      values.password
    )
  ) {
    errors.password = "Invalid password";
  }

  if (!values.businessName) {
    // errors.businessName = "Business name is required";
    setTimeout(() => {
      const element = document.getElementById("business_name");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus(); // Optional: Focus on the input field
      }
    }, 100);
    // toast.error(
    //   "Businessname is required"
    // );
  }
  
  
  return errors;
};

export const validateVertical = (values) => {
  console.log('values::: ', values);
  const errors = {};

  let firstErrorField = null;

  if (!values.businessName) {
    errors.businessName = "Business name is required";
    // toast.error("Business name is required");

    if (!firstErrorField) firstErrorField = "business_name";
  }

  if (!values.verticalId) {
    // errors.verticalId = "Select a vertical";
    // toast.error("Select a vertical");

    if (!firstErrorField) firstErrorField = "vertical_id"; 
  }

  // Scroll to the first error field
  if (firstErrorField) {
    setTimeout(() => {
      const element = document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus(); // Optional: Focus on the input field
      }
    }, 100);
  }
  return errors;
};


export const RegisterValidate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.password) {
    errors.password = "Password is required";
  }
  // else if (
  //   !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/i.test(
  //     values.password
  //   )
  // )
  //  {
  //   errors.password = "Invalid password";
  // }

  return errors;
};

export const validateRegister = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  return errors;
};

export const forgetpwValidate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }
  return errors;
};

export const validationResetPassword = (values) => {
  const errors = {};

  if (!values.newPassword) {
    errors.newPassword = "New password is required";
  } else if (
    !/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,16}$/.test(
      values.newPassword
    )
  ) {
    errors.newPassword =
      "Must Contain 8 to 16 Characters, One Uppercase, One Lowercase, One Number and one special case Character";
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = "Confirm Password is required";
  } else if (values.confirmPassword !== values.newPassword) {
    errors.confirmPassword = "Must Match With Password";
  }

  return errors;
};

export const validationSignUp = (values) => {
  const errors = {};

  function getDomainName(url) {
    try {
      // If the URL is missing "http" or "www", assume it's a raw domain and prepend "https://www."
      if (!/^https?:\/\//.test(url) && !/^www\./.test(url)) {
        url = "https://www." + url;
      } else if (url.startsWith("www.")) {
        url = "https://" + url;
      }

      const parsedUrl = new URL(url);
      let domain = parsedUrl.hostname;

      // Remove 'www.' if present
      if (domain.startsWith("www.")) {
        domain = domain.substring(4);
      }

      return domain;
    } catch (e) {
      console.error("Invalid URL:", e);
      return null;
    }
  }

  // Website URL Validation
  if (!values.website_url) {
    errors.website_url = "Website URL is required";
  } else {
    try {
      let formattedURL = values.website_url.trim();
  
      // Auto-correct URLs missing http(s)://
      if (!/^https?:\/\//.test(formattedURL)) {
        if (!/^www\./.test(formattedURL)) {
          formattedURL = "https://www." + formattedURL; // Default to https://www
        } else {
          formattedURL = "https://" + formattedURL; // If only www, add https://
        }
      } else if (/^https?:\/\/(?!www\.)/.test(formattedURL)) {
        formattedURL = formattedURL.replace(/^https?:\/\//, "https://www."); // Add www if missing
      }
  
      // Fix 'www.ww' by replacing it with 'www.'
      formattedURL = formattedURL.replace(/^https?:\/\/www\.ww\./, "https://www.");
  
      // Validate URL before parsing
      const domainRegex = /^(https?:\/\/)(www\.)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/.*)?$/;
      if (!domainRegex.test(formattedURL)) {
        errors.website_url = "Invalid website URL format";
        return;
      }
  
      // Now, parse the validated URL safely
      const url = new URL(formattedURL);
      console.log("Formatted URL::: ", url.href);
  
      // Extract domain name
      const websiteDomain = getDomainName(url.hostname).toLowerCase();
      const emailDomain = values.email?.split("@")[1]?.toLowerCase();
      console.log('emailDomain::: ', emailDomain);
  
      // Check if email domain matches website domain
      if (emailDomain && websiteDomain !== emailDomain) {
        console.log("Error Triggered: Website URL domain must match the Email domain");
        errors.website_url = "Website URL domain must match the Email domain";
        console.log('errors.website_url::: ', errors.website_url);
      }
  
      // Check if the URL matches the provided domain name
      if (values.domain_name && url.hostname.toLowerCase() === values.domain_name.toLowerCase()) {
        errors.website_url = "Website URL must not match Domain Name";
        return;
      }

      values.website_url = url.href;
    } catch (e) {
      errors.website_url = "Invalid URL format";
    }
  }

  if (!values.contactName) {
    errors.contactName = "Contact Name is required";
  }

  if (!values.businessName) {
    errors.businessName = "Business Name is required";
  }

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.password) {
    errors.password = "Password is required";
  } else if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,16}$/.test(values.password)) {
    errors.password =
      "Must Contain 8 to 16 Characters, One Uppercase, One Lowercase, One Number, and One Special Character";
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = "Confirm Password is required";
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = "Must Match With Password";
  }
if (!values.phoneNumber) {
  errors.phoneNumber = "Phone Number is required";
} else if (!isValidPhoneNumber(values.phoneNumber || "")) {
  errors.phoneNumber = "Invalid Phone Number";
}


  if (!values.country) {
    errors.country = "Country is required";
  }

  return errors;
};


export const validationContractfrom = (values) => {
  console.log("values::: ", values);
  const errors = {};

  if (!values.companyName) {
    errors.companyName = "Organization is required";
  }

  if (!values.name) {
    errors.name = "Name is required";
  }

  if (!values.comments) {
    errors.comments = "Comments is required";
  }

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.phone) {
    errors.phone = "Phone Number is required";
  } else if (
    !isValidPhoneNumber(values.phone === undefined ? "" : values.phone)
  ) {
    errors.phone = "Invalid Phone Number";
  }

  if (!values.country) {
    errors.country = "Country is required";
  }

  if (!values.timezone) {
    errors.timezone = "Timezone is required";
  }
  if (!values.hour) {
    errors.hour = "Hour slots is required";
  }

  return errors;
};
//   contactName: Yup.string()
//     .required("*Contact Name Is Required")
//     .min(1, "*Contact Name Must Be Between 1 and 50 Characters")
//     .max(50, "*Contact Name Must Be Between 1 and 50 Characters"),

//   email: Yup.string()
//     .required("*Email Address Is Required")
//     .matches(EmailRegex, "*Enter A Valid Email Address"),

//   password: Yup.string().required("Password Is Required"),

//   confirmPassword: Yup.string()
//     .required("Password Is Required")
//     .test('passwords-match', 'Incorrect Password', function(value){
//       return this.parent.password == value
//     }),

//   businessName: Yup.string()
//     .required("*Business Name Is Required")
//     .min(1, "*Business Name Must Be Between 1 and 50 Characters")
//     .max(50, "*Business Name Must Be Between 1 and 50 Characters"),

//   phoneNumber: Yup.string()
//     .required("*Phone Number Is Required")
//     .test("length", "Invalid Phone Number", (val) =>
//       isValidPhoneNumber(val == undefined ? "" : val)
//     ),
// });

export const validateOtp = (values) => {
  const errors = {};

  if (!values.phoneotp) {
    errors.phoneotp = "Phone OTP is required";
  } else if (values.phoneotp.length > 6) {
    errors.phoneotp = "Invalid OTP Length";
  }

  if (!values.emailotp) {
    errors.emailotp = "Email OTP is required";
  } else if (values.emailotp.length > 6) {
    errors.emailotp = "Invalid OTP Length";
  }
  return errors;
};
